import i18n from '@/locales/index';
// console.log(2222, i18n.global);
// 正则 固话+11位国内手机号，固话格式：010-12345678 固话支持3位或者4位区号中划线7位或者8位数字号码
export const phoneRegexp = /^(0\d{2,3})-[1-9]\d{6,7}$|^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
// 数组转对象
const arrToObj = (prev, cur) => {
  prev[cur.value] = cur.label;
  return prev;
};

//系统对象权限字符串枚举
export const objectRoleEnum = {
  1: 'clue',
  101: 'cluePool',
  2: 'customer',
  3: 'businessOpportunity',
  4: 'product',
  6: 'priceSheet',
  8: 'contract',
  10: 'saleOrder',
  12: 'afterSale',
  13: 'returnOrder',
  7: 'priceSheetProduct', //报价产品
  9: 'contractProduct', //合同产品
  11: 'saleOrderProduct', //订单产品
  14: 'returnOrderProduct', //退货单产品
  32: 'businessOpportunityProduct', //商机产品
  16: 'dynamicRecord'
};
export const objectIndexLinkPre = {
  1: '/leads/index',
  101: '/leads/pool',
  2: '/client/index',
  3: '/opportunity/index',
  4: '/product/index',
  6: '/price-sheet/index',
  8: '/contract/index',
  10: '/order/list',
  12: '/service/index',
  13: '/order/return-order',
  16: '/dynamic/index'
};

//系统对象跳转name
export const objectNameLinkPre = {
  1: 'leads',
  101: 'leads-pool',
  2: 'client',
  3: 'opportunity',
  4: 'product',
  6: 'price-sheet',
  8: 'contract',
  10: 'order',
  12: 'service',
  13: 'return-order-list-wrap',
  16: 'dynamic'
};
// 通话时长筛选
export const callLong = [
  { label: i18n.global.t('0~1分钟'), value: 0 },
  { label: i18n.global.t('1~5分钟'), value: 1 },
  { label: i18n.global.t('5~20分钟'), value: 2 },
  { label: i18n.global.t('20~30分钟'), value: 3 },
  { label: i18n.global.t('30分钟以上'), value: 4 }
];
export const callLongObj = callLong.reduce(arrToObj, {}); //{ 0: '0~1分钟', 1: '1~5分钟', 2: '5~20分钟', 3: '20~30分钟', 4: '30分钟以上' };
// 跟进方式筛选
export const followType = [
  { label: i18n.global.t('首电沟通'), value: '0' },
  { label: i18n.global.t('电话沟通'), value: '1' },
  { label: i18n.global.t('飞书/微信沟通'), value: '2' },
  { label: i18n.global.t('线上Pitch'), value: '3' },
  { label: i18n.global.t('线下拜访'), value: '4' },
  { label: i18n.global.t('走进字节'), value: '5' }
];
////华映资本租户的跟进方式
export const hyzbFollowType = [
  // { label: i18n.global.t('正式会议'), value: '0' },
  { label: '外部活动或大型会议', value: '1' },
  // { label: '茶叙', value: '2' },
  { label: '饭叙/茶叙', value: '3' },
  { label: '来华映参访', value: '4' },
  { label: '去LP处拜访', value: '5' },
  { label: '线上会议或电话访谈', value: '6' },
  { label: '电子邮件或微信', value: '8' },
  { label: '外部情报（未直接联系）', value: '7' }
];
////奇捷租户的跟进方式
export const qjkjFollowType = [
  { label: '线上会议', value: '0' },
  { label: '即时消息', value: '1' },
  { label: '现场支持', value: '2' },
  { label: '邮件', value: '3' },
  { label: '内部讨论', value: '4' },
  { label: '其他', value: '5' }
];
////奇捷租户的问题类别
export const qjkjProblemType = [
  { label: '工具需改进', value: '1' },
  { label: '需增加定制化功能', value: '2' },
  { label: '客户输入资料有误', value: '3' },
  { label: '需开放更多IT限制', value: '4' }
];
////奇捷租户的跟进人岗位
export const qjkjPositionType = [
  { label: '销售', value: '1' },
  { label: 'AE', value: '2' },
  { label: '研发', value: '3' }
];

// 奇捷跟进目的
export const qjkjfollowObjective = [
  { label: '拓展客户', value: 0 },
  { label: '初次沟通', value: 1 },
  { label: '初次现场拜访', value: 2 },
  { label: '增加交流', value: 3 },
  { label: '开发客户需求功能', value: 4 },
  { label: '申请测试', value: 5 },
  { label: '布置网络环境', value: 6 },
  { label: '测试产品', value: 7 },
  { label: '阶段总结', value: 8 },
  { label: '内部总结', value: 9 },
  { label: '确认合同细节', value: 10 },
  { label: '商务报价', value: 11 },
  { label: '推进商务', value: 12 },
  { label: '售后服务', value: 13 },
  { label: '其他', value: 14 }
];

export const followTypeObj = followType.reduce(arrToObj, {}); // { 0: '首电沟通', 1: '电话沟通', 2: '飞书/微信沟通', 3: '线上Pitch', 4: '线下拜访', 5: '走进字节' };
export const hyzbFollowTypeObj = hyzbFollowType.reduce(arrToObj, {});
export const qjkjFollowTypeObj = qjkjFollowType.reduce(arrToObj, {});
export const qjkjProblemTypeObj = qjkjProblemType.reduce(arrToObj, {});
export const qjkjPositionTypeObj = qjkjPositionType.reduce(arrToObj, {});
// 筛选条件的 枚举值
export const filterType = [
  { label: i18n.global.t('等于'), value: 0 },
  { label: i18n.global.t('不等于'), value: 1 },
  { label: i18n.global.t('包含'), value: 2 },
  { label: i18n.global.t('不包含'), value: 3 },
  { label: i18n.global.t('为空'), value: 4 },
  { label: i18n.global.t('不为空'), value: 5 }
];
export const filterTypeObj = filterType.reduce(arrToObj, {}); // { 0: '等于', 1: '不等于', 2: '包含', 3: '不包含', 4: '为空', 5: '不为空' };
export const displayOneLine = [
  // 0是1/2行展示，1是整行 2是1/3  3是2/3行展示
  { label: i18n.global.t('整行'), value: 1 },
  { label: i18n.global.t('1/2行'), value: 0 },
  { label: i18n.global.t('1/3行'), value: 2 },
  { label: i18n.global.t('2/3行'), value: 3 }
];
export const displayOneLineConifig = [
  // 0是两列展示，1是单列 2是三列
  { label: i18n.global.t('单列'), value: 1 },
  { label: i18n.global.t('两列'), value: 0 }
  // { label: i18n.global.t('三列'), value: 2 }
];
export const fieldType = [
  { label: i18n.global.t('单行文本'), value: 0 },
  { label: i18n.global.t('多行文本'), value: 1 },
  { label: i18n.global.t('单选按钮'), value: 2 },
  { label: i18n.global.t('多选按钮'), value: 3 },
  { label: i18n.global.t('下拉单选'), value: 4 },
  { label: i18n.global.t('下拉多选'), value: 5 },
  { label: i18n.global.t('人员'), value: 6 },
  { label: i18n.global.t('数字'), value: 7 },
  { label: i18n.global.t('日期'), value: 8 },
  { label: i18n.global.t('日期范围'), value: 9 },
  { label: i18n.global.t('级联选择'), value: 10 },
  { label: i18n.global.t('超链接'), value: 11 },
  { label: i18n.global.t('自增编码'), value: 13 },
  { label: i18n.global.t('金额'), value: 16 },
  { label: i18n.global.t('附件'), value: 18 },
  { label: i18n.global.t('引用字段'), value: 21 },
  { label: i18n.global.t('部门'), value: 22 },
  { label: i18n.global.t('百分比'), value: 23 },
  { label: i18n.global.t('计算类型'), value: 24 },
  { label: i18n.global.t('富文本'), value: 26 },
  { label: i18n.global.t('查找关联'), value: 12 },
  { label: i18n.global.t('查找关联(多选)'), value: 25 },

  { label: i18n.global.t('子表单'), value: 27 }
];
export const outFieldType = [
  { label: i18n.global.t('单行文本'), value: 0 },
  { label: i18n.global.t('多行文本'), value: 1 },
  { label: i18n.global.t('单选按钮'), value: 2 },
  { label: i18n.global.t('多选按钮'), value: 3 },
  { label: i18n.global.t('下拉单选'), value: 4 },
  { label: i18n.global.t('下拉多选'), value: 5 },
  { label: i18n.global.t('人员'), value: 6 },
  { label: i18n.global.t('数字'), value: 7 },
  { label: i18n.global.t('日期'), value: 8 },
  { label: i18n.global.t('日期范围'), value: 9 },
  { label: i18n.global.t('级联选择'), value: 10 },
  { label: i18n.global.t('超链接'), value: 11 },
  { label: i18n.global.t('查找关联'), value: 12 },
  { label: i18n.global.t('自增编码'), value: 13 },
  { label: i18n.global.t('秒级'), value: 14 },
  { label: i18n.global.t('毫秒级'), value: 15 },
  { label: i18n.global.t('金额'), value: 16 },
  { label: i18n.global.t('说明'), value: 17 },
  { label: i18n.global.t('附件'), value: 18 },
  { label: i18n.global.t('对象'), value: 19 },
  { label: i18n.global.t('明细'), value: 20 },
  { label: i18n.global.t('引用字段'), value: 21 },
  { label: i18n.global.t('部门'), value: 22 },
  { label: i18n.global.t('百分比'), value: 23 },
  { label: i18n.global.t('计算类型'), value: 24 },
  { label: i18n.global.t('查找关联(多选)'), value: 25 },
  { label: i18n.global.t('文档'), value: 26 },
  { label: i18n.global.t('计算公式'), value: 27 },
  { label: i18n.global.t('图片'), value: 28 },
  { label: i18n.global.t('图片V2'), value: 29 },
  { label: i18n.global.t('地址'), value: 30 },
  { label: i18n.global.t('关联审批'), value: 31 }
];
//飞书合同-数据回填字段类型
const contractFileType = [
  { label: i18n.global.t('单行文本'), value: 0 },
  { label: i18n.global.t('多行文本'), value: 1 },
  { label: i18n.global.t('单选'), value: 2 },
  { label: i18n.global.t('多选'), value: 3 },
  { label: i18n.global.t('人员'), value: 6 },
  { label: i18n.global.t('数字'), value: 7 },
  { label: i18n.global.t('日期'), value: 8 },
  { label: i18n.global.t('金额'), value: 16 }
];
export const fieldTypeObj = fieldType.reduce(arrToObj, {}); //  { 0: '单行文本', 1: '多行文本', 2: '单选按钮', 3: '多选按钮', 4: '下拉单选', 5: '下拉多选', 6: '人员', 7: '数字', 8: '日期', 9: '日期范围', 10: '级联选择', 11: '超链接', 12: '查找关联' };
export const outFieldTypeObj = outFieldType.reduce(arrToObj, {});

export const contractFieldTypeObj = contractFileType.reduce(arrToObj, {});
export const positionList = [
  { label: i18n.global.t('教师'), value: '教师' },
  { label: i18n.global.t('学生'), value: '学生' },
  { label: i18n.global.t('设计负责人'), value: '设计负责人' },
  { label: i18n.global.t('工程师'), value: '工程师' },
  { label: i18n.global.t('法人/CEO/老板'), value: '法人/CEO/老板' },
  { label: i18n.global.t('总经理'), value: '总经理' },
  { label: i18n.global.t('运营主管'), value: '运营主管' },
  { label: i18n.global.t('IT主管'), value: 'IT主管' },
  { label: i18n.global.t('技术负责人'), value: '技术负责人' },
  { label: i18n.global.t('市场主管'), value: '市场主管' },
  { label: i18n.global.t('首席数据官'), value: '首席数据官' },
  { label: i18n.global.t('财务主管'), value: '财务主管' },
  { label: i18n.global.t('副总裁/高级副总裁'), value: '副总裁/高级副总裁' },
  { label: i18n.global.t('部门负责人'), value: '部门负责人' },
  { label: i18n.global.t('总监/高级总监'), value: '总监/高级总监' },
  { label: i18n.global.t('经理/高级经理'), value: '经理/高级经理' },
  { label: i18n.global.t('普通员工'), value: '普通员工' },
  { label: i18n.global.t('其他'), value: '其他' },
  { label: i18n.global.t('人事负责人'), value: '人事负责人' },
  { label: i18n.global.t('销售主管'), value: '销售主管' },
  { label: i18n.global.t('行政主管'), value: '行政主管' },
  { label: i18n.global.t('业务主管'), value: '业务主管' },
  { label: i18n.global.t('产品负责人'), value: '产品负责人' }
];
//华映资本租户的联系人职位
export const huaYingOrdPositionList = [
  { label: i18n.global.t('董事长'), value: '董事长' },
  { label: 'CEO', value: 'CEO' },
  { label: 'MD/ED/Head', value: 'MD/ED/Head' },
  { label: 'VP', value: 'VP' },
  { label: i18n.global.t('投资总监'), value: '投资总监' },
  { label: i18n.global.t('投资经理'), value: '投资经理' },
  { label: i18n.global.t('秘书'), value: '秘书' },
  { label: i18n.global.t('其他管理层岗位'), value: '其他管理层岗位' },
  { label: i18n.global.t('其他执行层岗位'), value: '其他执行层岗位' }
];
export const positionListObj = positionList.reduce(arrToObj, {});
// 映射规则类型
export const ruleType = [
  { label: i18n.global.t('映射至外部系统'), value: 1 },
  { label: i18n.global.t('映射至烽火'), value: 2 }
];
export const fsRuleType = [
  { label: i18n.global.t('映射至飞书审批'), value: 1 },
  { label: i18n.global.t('映射至烽火'), value: 2 }
];
export const ruleTypeObj = ruleType.reduce(arrToObj, {});

export const isKDMList = [
  { label: i18n.global.t('是'), value: 0 },
  { label: i18n.global.t('否'), value: 1 },
  { label: i18n.global.t('老板委托调研人'), value: 2 },
  { label: i18n.global.t('暂不确定'), value: 3 }
];
export const isKDMObj = isKDMList.reduce(arrToObj, {});

//fieldType==0且需要筛选类型
export const checkboxOptions = [
  { label: i18n.global.t('否'), value: 0 },
  { label: i18n.global.t('是'), value: 1 }
];
//需要高级筛选的字段,工商id，客户id，是否存在日程，是否存在通话，是否存在跟进
// export const checkboxFieldList = ['qccId', 'customerId', 'calendarId', 'callId', 'recordId'];
//商机--业绩参与人角色
export const roleOptions = [
  { label: i18n.global.t('咨询顾问'), value: '咨询顾问' },
  { label: 'CSM', value: 'CSM' },
  { label: i18n.global.t('商务'), value: '商务' },
  { label: i18n.global.t('售前'), value: '售前' }
];
//商机--业绩参与人协作阶段
export const stageOptions = [
  { label: i18n.global.t('意向沟通(20%)'), value: '意向沟通(20%)' },
  { label: i18n.global.t('商机确认(20%)'), value: '商机确认(20%)' },
  { label: i18n.global.t('方案沟通(30%)'), value: '方案沟通(30%)' },
  { label: i18n.global.t('商务谈判(20%)'), value: '商务谈判(20%)' },
  { label: i18n.global.t('客户签约(10%)'), value: '客户签约(10%)' }
];
//地址类型
export const addressType = [
  { label: i18n.global.t('注册地址'), value: '注册地址' },
  { label: i18n.global.t('办公地址'), value: '办公地址' },
  { label: i18n.global.t('仓储地址'), value: '仓储地址' },
  { label: i18n.global.t('门店地址'), value: '门店地址' },
  { label: i18n.global.t('家庭地址'), value: '家庭地址' },
  { label: i18n.global.t('其他'), value: '其他' }
];
//抬头类型 invoiceType
export const invoiceType = [
  { label: i18n.global.t('个人'), value: '个人' },
  { label: i18n.global.t('单位'), value: '单位' }
];
// 客户成交状态
export const clientState = {
  0: i18n.global.t('未成交'),
  1: i18n.global.t('成交一次'),
  2: i18n.global.t('成交多次')
};
export const checkboxFieldList = ['qccId']; //操作高级搜索字段，（需要在高级搜索显示的字段）
export const inputFieldList = ['parentCustomerId', 'fsContractId']; //上级客户，飞书合同id（在下拉筛选不显示的字段,）

//开弦   147
export const kaixianOrgId = 147; //租户id

// 智书租户id 3
// 智书租户id 3 客户viewId=748
export const zhiShuOrgId = 3; //租户id
// prod
export const zhiShuOrgMenuGroupId = 1025; //售后组id test371 dev452  pro上组142  线上组1025
export const zhiShuOrgViewId = 1154; //客户视图id test95 dev874 dev pro视图42 线上视图1154
export const zhiShuOrgViewIds = [1154, 1220, 1221, 1222, 1634, 4794, 4795, 3525]; //客户视图id dev[874,541] test[95] pro视图[] 线上[1154, 1220, 1221, 1222]
// test
// export const zhiShuOrgMenuGroupId = 818; //售后组id test371 dev452  pro上组142  线上组1025
// export const zhiShuOrgViewId = 95; //客户视图id test95 dev874 dev pro视图42 线上视图1154
// export const zhiShuOrgViewIds = [95]; //客户视图id dev[874,541] test[95] pro视图[] 线上[1154, 1220, 1221, 1222]
// 演示环境线上
export const yanShiOrgId = 4; // 租户id
// 条条是道 id12
export const tiaoDaoOrgId = 12; //租户id
// 条条是道新租户 31372
export const tiaoDaoNewOrgId = 31372; //租户id
// 华映资本 14
export const huaYingOrdId = 14; // 租户id
// 华映资本的另一个系统 385
export const hyzbOrgId = 385; // 租户id
// 华映资本的另一个系统的单独菜单1【子基金管理】 385 prod
export const hyzbOrgMenuGroupId = 4412; //子基金管理 test371 dev452  pro上组142  线上组1025
export const hyzbOrgViewId = 5019; //客户视图id test95 dev874 dev pro视图42 线上视图1154
export const hyzbOrgViewIds = [5019]; //客户视图id dev[874,541] test[95] pro视图[] 线上[1154, 1220, 1221, 1222]
//中谦检测 19
export const zqjcOrgId = 19; //租户id
//餐饮 45
export const canYinOrgId = 45; //租户id
//儒朋科技 rupengkeji
export const ruPengOrgId = 49; //租户id
//领储 7
export const lingChuOrgId = 7; // 租户id
//mcn 演示租户id26
export const mcnDemoOrgId = 26; //演示租户id
//奇捷科技 id38
export const qijieOrgId = 38; //租户id
//yunmin 66
export const yunminOrgId = 66; //yunmin租户id
// 米高梅客户传显外呼处理
export const mgmOrgId = 430; // 租户id
// 仅优矩互动(Bing)租户id=39
export const bingOrgId = 39; //租户id
export const bingEntity = 200; //线上bing租户的entity
// 禾风//测试环境（pro）租户id是2313//正式环境租户id是48
export const hfOrgId = 48;
// 外联发送租户id
export const wlfOrgId = 142;
//创易智企
export const cyzqOrgId = 31654;

// 组织架构三方登录--需要隐藏的功能--变量默认false将来开启时修改为true
export const hiddenFeature = false;
// 传显科技外呼 租户id
export const cxwhOrgIds = [tiaoDaoOrgId, tiaoDaoNewOrgId, yanShiOrgId, ruPengOrgId, zhiShuOrgId, mgmOrgId, yunminOrgId];
// 默认值灰度，不在灰度内的才生效
export const defaultValOrgIds = [1, 2];
// 对象映射关系列表
export const objEntityMapping = {
  1: 'clue',
  2: 'customer',
  3: 'businessOpportunity',
  4: 'product',
  6: 'priceSheet',
  8: 'contract',
  10: 'saleOrder',
  12: 'afterSale',
  11: 'saleOrderProduct', //订单产品
  13: 'returnOrder',
  16: 'dynamicRecord',
  7: 'priceSheetProduct', //报价产品
  9: 'contractProduct', //合同产品
  14: 'returnOrderProduct', //退货单产品
  32: 'businessOpportunityProduct', //商机产品
  101: 'cluePool'
};
// 联系人--个人重要性
export const personImportantList = [
  { label: i18n.global.t('非常重要'), value: 1 },
  { label: i18n.global.t('较重要'), value: 2 },
  { label: i18n.global.t('一般'), value: 3 },
  { label: i18n.global.t('未知'), value: 4 }
];
export const personImportantObj = personImportantList.reduce(arrToObj, {});
// 计算类型内容
export const calculationList = [
  {
    value: 7,
    label: i18n.global.t('数字'),
    desc: i18n.global.t('计算结果等于数字，示例：总数量 = 购买数量 + 赠送数量')
  },
  {
    value: 23,
    label: i18n.global.t('百分比'),
    desc: i18n.global.t('计算结果自动加百分比，示例：折扣 = 折后价 / 原价')
  },
  {
    value: 16,
    label: i18n.global.t('金额'),
    desc: i18n.global.t('计算结果等于金额，示例：总金额 = 单价 * 数量')
  },
  {
    value: 0,
    label: i18n.global.t('文本'),
    desc: i18n.global.t('计算结果等于文本，一般用于串联其他字段，示例：商机名称 = CONCATENATE(客户名称 ， 创建日期)')
  },
  {
    value: 5,
    label: i18n.global.t('数字（汇总累计）'),
    desc: i18n.global.t('计算结果等于数字，一般用于汇总关联对象的数量，示例：统计客户下订单数量')
  },
  {
    value: 6,
    label: i18n.global.t('金额（汇总累计）'),
    desc: i18n.global.t('计算结果等于金额，一般用于汇总关联对象的金额，示例：统计客户下所有订单总金额')
  }
  //   {
  //     value: 8,
  //     label: '日期',
  //     desc: '计算结果等于日期，示例：预计结单日期 = 创建日期 + 7'
  //   }
];
// 计算公式有关
//运算符
export const operatorOptions = [
  [
    { label: '+', value: '0', op: '+（加号）', des: '两个字段/数值相加，数字类型字段相加效果为1+1=2，非数字类型相加效果为张三+李四=张三李四' },
    { label: '-', value: '1', op: '-（减号）', des: '两个字段/数值相减 ' },
    { label: '*', value: '2', op: '*（乘号）', des: '两个字段/数值相乘' },
    { label: '/', value: '3', op: '/（除号）', des: '两个字段/数值相除' },
    { label: '(', value: '4', op: '( 左括号 ', des: '使用时必须有对应的右括号匹配，例如：不含税总价=含税总价/（1+税率）' },
    { label: ')', value: '5', op: ') 右括号 ', des: '使用时必须有对应的左括号匹配，例如：不含税总价=含税总价/（1+税率）' },
    //   { label: '&串联', value: '6', op: '&' },
    { label: '>', value: '7', op: '>（大于)', des: '常用于作为函数判断条件，例如：判断客户成交额大于1W的为重点客户，IF(成交金额>10000,“重点客户""非重点客户")' },
    { label: '>=', value: '8', op: '>=（大于等于)', des: '常用于作为函数判断条件，例如：判断分数大于等于60则为及格，IF(分数>=60,“及格""不及格")' },
    { label: '<', value: '9', op: '<（小于)', des: '常用于作为函数判断条件，例如：判断分数小于60则为不及格，IF(分数＜60,“不及格""及格")' },
    { label: '<=', value: '10', op: '<=（小于等于)', des: '常用于作为函数判断条件，例如：判断客户成交额小于等于1W的为非重点客户，IF(成交金额＜=10000,“非重点客户""重点客户")' },
    { label: '==', value: '11', op: '==（等于)', des: '常用于作为函数判断条件，例如：判断合同数量等于0的客户是未成交客户，IF(合同数量==0,“未成交客户""成交客户")' },
    { label: '!=', value: '12', op: '!=（不等于)', des: '常用于作为函数判断条件，例如：判断合同数量不等于0的客户是成交客户，IF(合同数量!=0,“成交客户""未成交客户")' },
    { label: '&&', value: '13', op: '&&（与运算，等同于AND）', des: '常用于作为函数判断条件，例如：判断0＜执行进度＜1的商机是执行中状态，IF(AND（执行进度＞0，执行进度＜1）,“执行中""非执行中")' },
    { label: '||', value: '14', op: '||（或运算，等同于OR）', des: '常用于作为函数判断条件，例如：判断执行进度=0或=1的商机是非执行中状态，IF(OR（执行进度=0，执行进度=1）,“非执行中""执行中")' }
  ]
];
// 数字保留位数
export const dataFormatOptions = [
  { label: '整数', value: '0' },
  { label: '保留1位小数', value: '1' },
  { label: '保留2位小数', value: '2' },
  { label: '保留3位小数', value: '3' },
  { label: '保留4位小数', value: '4' },
  { label: '保留5位小数', value: '5' },
  { label: '保留6位小数', value: '6' },
  { label: '保留7位小数', value: '7' },
  { label: '保留8位小数', value: '8' }
];
// 数字(汇总累计)保留位数
export const dataSummaryFormatOptions = [
  { label: '整数', value: '0' },
  { label: '保留1位小数', value: '1' },
  { label: '保留2位小数', value: '2' },
  { label: '保留3位小数', value: '3' },
  { label: '保留4位小数', value: '4' },
  { label: '保留5位小数', value: '5' },
  { label: '保留6位小数', value: '6' }
];
// 金额百分比保留位数
export const percentageOptions = [
  { label: '整数', value: '0' },
  { label: '保留1位小数', value: '1' },
  { label: '保留2位小数', value: '2' },
  { label: '保留3位小数', value: '3' },
  { label: '保留4位小数', value: '4' },
  { label: '保留5位小数', value: '5' }
];
// 日期格式
export const dateOptions = [
  { label: '2023/01/01', value: 'YYYY/MM/DD' },
  { label: '2023/1/01', value: 'YYYY/M/DD' },
  { label: '2023/01/01 14:00', value: 'YYYY/MM/DD HH:mm' },
  { label: '2023-1-01', value: 'YYYY-M-DD' },
  { label: '2023-01-01', value: 'YYYY-MM-DD' },
  { label: '2023-01-01 14:00', value: 'YYYY-MM-DD HH:mm' }
];
// 布局内置对象
export const layoutBuiltObj = {
  // 线索
  1: [
    { label: '联系人', value: 'linkMan' },
    { label: '通话记录', value: 'callRecord' },
    { label: '日程', value: 'schedule' },
    { label: '分配记录', value: 'allocationRecord' },
    { label: '审批记录', value: 'approvalRecord' }
  ],
  // 客户
  2: [
    { label: '联系人', value: 'linkMan' },
    { label: '通话记录', value: 'callRecord' },
    { label: '日程', value: 'schedule' },
    { label: '开票信息', value: 'invoice' },
    { label: '地址信息', value: 'address' },
    { label: '下级客户', value: 'lowerCustomer' },
    { label: '线索转化记录', value: 'transferRecord' },
    { label: '资料沉淀', value: 'cloud' },
    { label: '审批记录', value: 'approvalRecord' }
  ],
  // 商机
  3: [
    { label: '联系人', value: 'linkMan' },
    // { label: '业绩参与人', value: 'partMan' },
    { label: '通话记录', value: 'callRecord' },
    { label: '日程', value: 'schedule' },
    { label: '线索转化记录', value: 'transferRecord' },
    { label: '资料沉淀', value: 'cloud' },
    { label: '审批记录', value: 'approvalRecord' }
  ],
  // 产品
  4: [
    { label: '价格信息', value: 'priceInfo' },
    { label: '审批记录', value: 'approvalRecord' }
  ],
  // 报价单
  6: [{ label: '审批记录', value: 'approvalRecord' }],
  // 销售合同
  8: [
    { label: '资料沉淀', value: 'cloud' },
    { label: '审批记录', value: 'approvalRecord' }
  ],
  // 订单
  10: [{ label: '审批记录', value: 'approvalRecord' }],
  // 售后服务
  12: [
    // { label: '客户关键联系人', value: 'customerLinkMan' },
    // { label: '商机', value: 'opportunity' },
    { label: '资料沉淀', value: 'cloud' },
    // { label: '客户特征', value: 'feature' },
    // { label: '客户伙伴数据(天维度)', value: 'partner' },
    { label: '审批记录', value: 'approvalRecord' }
  ],
  // 退货单
  13: [{ label: '审批记录', value: 'approvalRecord' }]
};

export const entityTypeMap = [
  { value: 1, label: i18n.global.t('销售线索') },
  { value: 2, label: i18n.global.t('客户') },
  { value: 3, label: i18n.global.t('商机') },
  { value: 4, label: i18n.global.t('产品') },
  { value: 6, label: i18n.global.t('报价单') },
  { value: 7, label: i18n.global.t('报价单-产品') },
  { value: 8, label: i18n.global.t('合同') },
  { value: 9, label: i18n.global.t('合同-产品') },
  { value: 10, label: i18n.global.t('销售订单') },
  { value: 11, label: i18n.global.t('销售订单-产品') },
  { value: 12, label: i18n.global.t('售后服务单') },
  { value: 13, label: i18n.global.t('退货单') },
  { value: 14, label: i18n.global.t('退货单-产品') },
  { value: 31, label: i18n.global.t('商机云文档/附件') },
  { value: 32, label: i18n.global.t('商机-产品') },
  { value: 99, label: i18n.global.t('动态记录') },
  { value: 101, label: i18n.global.t('线索池') }
];

export const btnShowOptions = [
  {
    label: i18n.global.t('图标+文字展示'),
    value: 0
  },
  {
    label: i18n.global.t('图标展示'),
    value: 1
  },
  {
    label: i18n.global.t('文字展示'),
    value: 2
  }
];

export const btnTypePositions = [
  {
    label: i18n.global.t('列表布局-通用操作'),
    value: '0'
  },
  {
    label: i18n.global.t('列表布局-批量操作'),
    value: '1'
  },
  {
    label: i18n.global.t('列表布局-快捷操作'),
    value: '2'
  },
  {
    label: i18n.global.t('新建布局'),
    value: '3'
  },
  {
    label: i18n.global.t('编辑布局'),
    value: '4'
  },
  {
    label: i18n.global.t('详情布局'),
    value: '5'
  }
];

export const btnCountShowOptions = [
  {
    label: i18n.global.t('显示1个'),
    value: '1'
  },
  {
    label: i18n.global.t('显示2个'),
    value: '2'
  },
  {
    label: i18n.global.t('显示3个'),
    value: '3'
  },
  {
    label: i18n.global.t('显示4个'),
    value: '4'
  }
];

export const confine = {
  number301: 301,
  number300: 300,
  number501: 501,
  number500: 500,
  number3000: 3000,
  number3001: 3001,
  number20001: 20001,
  number20000: 20000,
  number5001: 5001,
  number5000: 5000,
  number10001: 10001,
  number10000: 10000
};

/* 外联发红冲定制 */

export const HongChongInfo = {
  viewId: 6305, // 5959
  noteInfo: {
    //开票状态字段信息
    fieldKey: 'select_single_bZrCX5', //select_single_yehSCH
    fieldValue: '3' //3 TErXas
  }
};

export const btnTypeObj = {
  0: i18n.global.t('预置按钮'),
  1: i18n.global.t('自定义')
};
// 自动化流程引擎的触发动作
export const triggerActionList = [
  { label: i18n.global.t('新增记录'), value: 30 },
  { label: i18n.global.t('记录内容变更'), value: 40 },
  { label: i18n.global.t('新增/修改的记录满足条件'), value: 50 },
  { label: i18n.global.t('定时触发'), value: 60 }
];
export const triggerActionObj = triggerActionList.reduce(arrToObj, {});
// 自动化流程引擎的操作方式
export const triggerInfoList = [
  { label: i18n.global.t('新增记录'), value: 3 },
  { label: i18n.global.t('修改记录'), value: 4 },
  { label: i18n.global.t('发送飞书消息'), value: 2 },
  { label: i18n.global.t('AI生成内容'), value: 5 },
  { label: i18n.global.t('查找记录'), value: 1 },
  { label: i18n.global.t('循环新增记录'), value: 6 },
  { label: i18n.global.t('循环修改记录'), value: 7 }
];
// 自动化流程Ai灰度发布
// export const autoAi = [3, 4, 14, 119, 182, 192, 217, 232, 247, 286, 385, 31121, 31122, 31200, 31212, 31240, 31373, 31379, 31385, 31466, 31372, 31552, 31720, 3151, 31727, 31705, 31764, 31774, 408, 67, 293];

// 字段属性控制脱离布局白名单 以下Orgid走旧版本
// export const fieldAttributeOutLayout = [31654, 31652, 31622, 31611, 31579, 31576, 31542, 31494, 31490, 31489, 31387, 31372, 31359, 31340, 31313, 31274, 31157, 31151, 31123, 434, 406, 405, 385, 207, 142, 141, 48, 66, 14, 19, 26, 39, 53, 38, 7, 4];
// export const fieldAttributeOutLayout = [3];
// 只读特殊处理 不展示默认提示文本
export const fieldAttributeReadOnly = [13, 21, 24];
// 隐藏特殊处理
export const fieldTypeHideDisabled = [0, 13, 21, 24];

//新建编辑走布局 数组内租户走旧版本弹窗
export const oldLayoutUserIds = [7, 14, 19, 36, 38, 48, 53, 62, 115, 142, 406, 430, 31151, 31157, 31274, 31313, 31340, 31358, 31359, 31439, 31490, 3, 66, 207, 434, 31160, 31350, 31372, 31387, 31485, 31489, 39, 4, 147, 31379, 31430, 3129];
// 计算字段Today灰度
// export const todayGrayScaleOrgId = [31372, 39434, 31485, 31517, 31387, 48, 31622, 31157, 31622, 320];
//业务规则白名单
// export const businessRuleWhiteList = [31379, 3, 4, 31430, 66, 48, 3129, 408, 207, 31439, 31517, 320, 31622, 31559, 31157, 31488];
// 转换成对象
export const triggerInfoObj = triggerInfoList.reduce(arrToObj, {});

// 不支持编辑的字段类型
export const editFieldTypeList = [13, 21, 24, 27]; //这些字段类型及被引用字段类型不支持编辑
// 对象下不支持的编辑字段
export const editEntityList = { 1: ['followUser'], 2: ['chargePerson', 'qccId'], 3: ['opportunityStage', 'opportunityStatus', 'chargePerson'], 4: ['chargePerson', 'taxRate'], 6: ['chargePerson'], 7: ['chargePerson'], 8: ['chargePerson'], 9: ['chargePerson'], 10: ['chargePerson'], 11: ['chargePerson'], 12: ['csmChargePerson'], 13: ['chargePerson'], 14: ['chargePerson'], 32: ['chargePerson'], 101: ['followUser'] };
// 合同对象列表特殊处理字段类型(这些字段不会进入可编辑组件，默认是不可编辑的文本)
export const contractFieldKey = ['fsContractCode', 'fsContractId', 'fsContractGroupId', 'fsContractTemplateId', 'kxFsContractUrl'];

//对象编辑页不可修改字段列表
export const objectDisableFieldKeys = ['followUser', 'chargePerson', 'csmChargePerson'];

// 自动化日志操作类型
export const DetailMap = {
  0: '默认逻辑',
  1: '查找数据',
  2: '发送飞书消息',
  3: '新增记录',
  4: '修改记录',
  5: 'AI节点',
  6: '循环新增记录',
  7: '循环修改记录'
};
// 只支持 数字 金额 计算类型(不含文本) 百分比 日期
export const constFieldSort = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 12, 16, 22, 23, 24, 25];

export const outCallConfig = {
  am: { name: '艾盟营销', platformCode: '双呼模式，可在手机上直接与客户通话' },
  cx: { name: '传显科技', platformCode: '外部RTC模式，可在网页上直接与客户通话' },
  tr: { name: '天润融通', platformCode: '双呼模式，可在手机上直接与客户通话' },
  kty: { name: '科天云', platformCode: '双呼模式，可在手机上直接与客户通话' }
};

// 审批规则监听状态
export const statusOptions = [
  {
    label: '审批中',
    value: 'PENDING'
  },
  {
    label: '已通过',
    value: 'APPROVED'
  },
  {
    label: '已拒绝',
    value: 'REJECTED'
  },
  {
    label: '已撤回',
    value: 'CANCELED'
  },
  {
    label: '已删除',
    value: 'DELETED'
  },
  {
    label: '已撤销',
    value: 'REVERTED'
  }
  // {
  //   label: '超时被关闭',
  //   value: 'OVERTIME_CLOSE'
  // },
  // {
  //   label: '超时实例被恢复',
  //   value: 'OVERTIME_RECOVER'
  // }
];
export const permissionsObjList = {
  //编辑权限
  1: 'clue:edit',
  2: 'customer:edit',
  3: 'businessOpportunity:edit',
  4: 'product:edit',
  6: 'priceSheet:edit',
  //   7: '报价单产品',
  8: 'contract:edit',
  //   9: '合同产品',
  10: 'saleOrder:edit',
  //   11: '订单产品',
  12: 'afterSale:edit',
  13: 'returnOrder:edit',
  16: 'dynamicRecord:edit',
  //   14: '退货单产品',
  //   32: '商机产品',
  101: 'cluePool:edit'
};

//客户级别公共样式
export const levelColors = {
  A类: 'cyan',
  B类: 'arcoblue',
  C类: 'pinkpurple',
  '': 'gray'
};
// 租户的灰度key值
export const grayscaleObj = {
  defVal: 1 //默认值
};
// AI点数重试按钮灰度命中字段
export const aiPointsGrayFieldRules = Object.freeze([{ entity: 206, fieldKey: 'select_single_HQ7X8e' }]);
// AI点数重试接口 requestid 取值字段
export const aiPointsRequestIdFieldKey = 'input_fadXia';
// AI点数重试前校验依赖的特殊字段
export const aiPointsRetryValidateFieldConfig = Object.freeze({
  // 生效时间
  effectiveAtFieldKey: 'date_JakAhs',
  // 到期时间
  expiryAtFieldKey: 'date_iPCHza',
  // 充值点数
  rechargeAmountFieldKey: 'number_kB3pzm'
});
// AI点数复制场景初始化时需要清空的字段
export const aiPointsCopyClearFieldKeys = Object.freeze([aiPointsRequestIdFieldKey]);
// AI点数重试按钮展示依赖的充值结果字段；当前仅在结果明确为“失败”时展示重试按钮。
export const aiPointsRetryResultFieldConfig = Object.freeze({
  fieldName: '充值结果',
  fieldKey: 'select_single_nzKNN7',
  failureOption: {
    value: 'GW73j6',
    text: '失败'
  }
});
// AI点数按钮文案
export const aiPointsRetryButtonLabel = '重试';
// AI点数按钮二次确认文案
export const aiPointsRetryConfirmTitle = '确认重试该条充值记录？';
export const aiPointsRetryConfirmContent = '确认后，将重新发起该条充值请求。';
// AI点数按钮成功提示
export const aiPointsRetrySuccessMessage = '操作成功！';
//跟进建议标签样式
export const adviceColors = { 建议转化: '#37b41a', 建议无效: 'var(--color-text-2)', 待定: 'gold', 待处理: 'orange', '': 'gray' };

// 数据状态 1 计算中 3 处理中
export const computingStatus = [1, 3];

// 空数据样式
export const emptyText = '—';

// BI特殊处理 - 虚线空格  - 后的空格 空格不要删 加空格是为了避免字段值重复
export const dashSpace = '— ';

// 查找关联-空数据样式
export const associationEmptyText = '未命名记录';

//自动化流程 - 特殊标识
export const SESSION_KEY = {
  SEARCH_PARAMS: 'searchParams',
  PAGE_NATION: 'pageNation'
};
// 通用按钮导出最大条数限制
export const MAX_EXPORT_COUNT = 30000;
